/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TagSuggestionResource
 */
export interface TagSuggestionResource {
    /**
     * 
     * @type {string}
     * @memberof TagSuggestionResource
     */
    tag?: string;
    /**
     * 
     * @type {string}
     * @memberof TagSuggestionResource
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof TagSuggestionResource
     */
    occurrences: number;
    /**
     * 
     * @type {string}
     * @memberof TagSuggestionResource
     */
    universe: string;
}

/**
 * Check if a given object implements the TagSuggestionResource interface.
 */
export function instanceOfTagSuggestionResource(value: object): value is TagSuggestionResource {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('occurrences' in value) || value['occurrences'] === undefined) return false;
    if (!('universe' in value) || value['universe'] === undefined) return false;
    return true;
}

export function TagSuggestionResourceFromJSON(json: any): TagSuggestionResource {
    return TagSuggestionResourceFromJSONTyped(json, false);
}

export function TagSuggestionResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagSuggestionResource {
    if (json == null) {
        return json;
    }
    return {
        
        'tag': json['tag'] == null ? undefined : json['tag'],
        'label': json['label'],
        'occurrences': json['occurrences'],
        'universe': json['universe'],
    };
}

export function TagSuggestionResourceToJSON(value?: TagSuggestionResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tag': value['tag'],
        'label': value['label'],
        'occurrences': value['occurrences'],
        'universe': value['universe'],
    };
}

